var React = require('react');

function WarningIconSmall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".warning-icon-small-svg{fill:#f12938;}")),React.createElement("path",{"className":"warning-icon-small-svg","d":"M6.52,0C3.83,0-1,9.05.18,10.19s11.67,1,12.68,0S9.22,0,6.52,0ZM6,2H7V7H6ZM7,9.09H6v-1H7Z","key":1})]);
}

WarningIconSmall.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 13 11","width":"13","height":"11"};

module.exports = WarningIconSmall;

WarningIconSmall.default = WarningIconSmall;
